import { render, staticRenderFns } from "./vivoReport.vue?vue&type=template&id=58d9a924&scoped=true&"
import script from "./vivoReport.vue?vue&type=script&lang=js&"
export * from "./vivoReport.vue?vue&type=script&lang=js&"
import style0 from "./vivoReport.vue?vue&type=style&index=0&id=58d9a924&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d9a924",
  null
  
)

export default component.exports